<template>
    <footer class="fx ai-c jc-c">
        <div class="txt-center">Designed and developed by <span>Ben.</span> Copyright  © 2023 Benjamin Ayimah. All rights reserved.</div>
    </footer>
</template>
<style lang="scss" scoped>
footer{
    margin-top: 30px;
    height: 100px;
    font-size: 13px;
    padding: 0 20px;
    span {
        font-weight: 500;
    }
}
</style>